module.exports = __webpack_public_path__ + "static/img/zhanshi.0ee717d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/zhanshi.png
// module id = XAIz
// module chunks = 1